import { IonContent, IonPage, useIonViewDidEnter } from '@ionic/react'
import React, { useState } from 'react'
import './BindBot.css'
import { ClipIcon } from '../conf/images'
import CopyToClipboard from 'react-copy-to-clipboard'
import Toast from '../components/Toast'
import { useSelector } from 'react-redux'
import { ReduxStore } from '../redux/reducers'
import { UserModel } from '../model/user.model'
import { SigninPage, ProductIntroPage } from '../conf/routePath'
import Header from '../components/Header'
import { useHistory } from 'react-router'
import { postUserAction } from '../service/api/bot'
interface BotInfoItemProps {
    title?: string
    text?: string
}
const BotInfoItem: React.FC<BotInfoItemProps> = (props) => {
    const { title, text = '' } = props
    const [toastOpen, setToastOpen] = useState(false)
    const userInfo = useSelector<ReduxStore, UserModel | null>(
        (store) => store.userInfo
    )
    if (!userInfo) {
        window.location.replace(SigninPage)
        return null
    }
    return (
        <div className='bot-info-item'>
            <p className='title'>{title}</p>
            <CopyToClipboard
                text={text}
                onCopy={() => {
                    setToastOpen(true)
                }}
            >
                <div className='text'>
                    <span className='ellipsis'>{text}</span>
                    <img src={ClipIcon} alt='icon' />
                </div>
            </CopyToClipboard>
            <Toast
                message='已复制'
                color='success'
                position='top'
                isOpen={toastOpen}
                onClose={() => setToastOpen(false)}
            />
        </div>
    )
}

const BindBot: React.FC = () => {
    const userInfo = useSelector<ReduxStore, UserModel | null>(
        (state) => state.userInfo
    )
    const history = useHistory()
    useIonViewDidEnter(() => {
        postUserAction('wechaty_refresh')
    })
    return (
        <IonPage className='bindbot-page'>
            <IonContent className='content'>
                {/* <div className='header'>绑定机器人</div> */}
                <Header title='绑定机器人' />
                <div className='main'>
                    <div className='introduction section'>
                        <span className='num'>1</span>
                        <p>登录WeTool企业版，以用作机器人的微信号扫码登陆</p>
                    </div>
                    <div className='section'>
                        <div className='introduction'>
                            <span className='num'>2</span>
                            <p>
                                在WeTool企业版机器人中，添加吾来机器人，并填入下面的公钥和私钥
                            </p>
                        </div>
                        <div className='bot-info-items'>
                            {/* 在WeTool企业版机器人中，添加吾来机器人，并填入下面的公钥和私钥
							<p className="title">
								
							</p> */}
                            <BotInfoItem
                                title='公钥'
                                text={
                                    userInfo
                                        ? userInfo.extra.wulai.store.user.pubkey
                                        : ''
                                }
                            />
                            <BotInfoItem
                                title='私钥'
                                text={
                                    userInfo
                                        ? userInfo.extra.wulai.store.user.secret
                                        : ''
                                }
                            />
                        </div>
                    </div>
                    {/* <div className="introduction"> */}
                    {/* <span className="num">2</span> */}

                    {/* </div> */}
                    <div className='introduction section'>
                        <span className='num'>3</span>
                        <p>
                            修改回复对象，添加机器人需要服务的群；修改回复延时为1秒
                        </p>
                    </div>

                    <p
                        className='product-link'
                        onClick={() => history.push(ProductIntroPage)}
                    >
                        详情查看《产品使用手册》->
                    </p>
                    <a href='/manual'>详情点击《来小秘使用手册》</a>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default BindBot
